import {v4 as uuidv4} from "uuid";
import { faker } from "@faker-js/faker";
import { getBotType } from "../../modules/day2-bots/utils";
import { getTaskType } from "../../modules/admin-tasks/actions/tasks";
import {
  DESIRED_ACCOUNT_STATE_TASK_ID,
  DESIRED_REGION_STATE_TASK_ID,
  BOT_TYPE_SECURITY,
  BOT_TYPE_COMPLIANCE,
} from "../../utils/app-constants.json";

export const allCustomTasks = (botId) => {
  const allCustomTasks = [
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Start an EC2 instance",
      ID: "3484f47d-037f-55d8-bfe1-0ea30df4d9a3",
      IsEnable: true,
      Metadata: {},
      Name: "start",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Power off an EC2 instance",
      ID: "f56098f6-52cb-5975-b30e-628bf5ed2662",
      IsEnable: true,
      Metadata: {},
      Name: "stop",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Restart the EC2 instance",
      ID: "52939b92-9bcf-51c9-940c-1a2c2ba4e711",
      IsEnable: true,
      Metadata: {},
      Name: "restart",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Deletes the targeted EC2 instance",
      ID: "e5877d1d-207f-5628-8aa7-6621e4f07754",
      IsEnable: true,
      Metadata: {},
      Name: "terminate",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Storage",
      CreatedBy: null,
      Description:
        "Create a snapshot from an existing EC2 instance (all volumes), or from an individual EBS volume",
      ID: "82dfc3ac-14e2-5f75-bedf-5e9f8e2c0074",
      IsEnable: true,
      Metadata: {},
      Name: "createSnapshot",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "PATCH-SCAN",
      CreatedBy: null,
      Description:
        "Scan and compare one or more instances against a security baseline",
      ID: "61007049-d9cb-57f0-80d9-0380f4b53d97",
      IsEnable: true,
      Metadata: {},
      Name: "scanPatch",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "PATCH-INSTALL",
      CreatedBy: null,
      Description:
        "Deploy patches from a security baseline against one or more instances.  Please note that it is required to scan the instances prior to attempting a patch operation",
      ID: "edae34a5-f97e-5e66-8574-6cf2389adc8d",
      IsEnable: true,
      Metadata: {},
      Name: "installPatch",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "DESIRED-SERVER-STATE",
      CreatedBy: null,
      Description:
        "Checks one or more instances for compliance against a Desired Server State policy, carrying out any remediation as defined in the policy",
      ID: "910237dc-319d-5d74-a78e-c1a43bf2f172",
      IsEnable: true,
      Metadata: {
        ShouldContinueNextOnFail: true,
        SplitTaskBasedOn: "$.Policy.Rules",
        SplitTasks: true,
      },
      Name: "executeDss",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description:
        "Creates an AMI from an existing AWS EC2 instance.  Not applicable for on-premise/managed instances",
      ID: "4ebc6ca4-c7de-5dec-8d45-67806ffafffc",
      IsEnable: true,
      Metadata: {},
      Name: "createImage",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description:
        "Download and deploy the Amazon CloudWatch agent onto a given instance, whether in cloud or on-premise",
      ID: "db40a540-0180-5025-8bc7-ce0a393d4258",
      IsEnable: true,
      Metadata: {},
      Name: "configureCloudWatchAgent",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Duplicates an Amazon Machine Image to another region",
      ID: "ea71e331-0db1-582d-aadf-54c93a9abc41",
      IsEnable: true,
      Metadata: {},
      Name: "copyImage",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description:
        "Share an Amazon Machine Image with other AWS accounts privately, or make the image publicly available to any account",
      ID: "245a2b65-679e-5f0e-afe2-932aeee7ccc1",
      IsEnable: true,
      Metadata: {},
      Name: "shareImage",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Volume",
      CreatedBy: null,
      Description: "Modifies the EBS Volume Type for selected EBS Volumes",
      ID: "18262e20-0ab4-5429-91c7-537d88095958",
      IsEnable: true,
      Metadata: { GlobalTask: true, Label: "Modify Volume Type" },
      Name: "modifyEBSVolumeType",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "68557b5a-cd94-452b-b22b-5fe0dc69d023",
            label: "Modify Amazon EBS volumes",
            parameters: [
              {
                description:
                  "The ID's of the Amazon EBS volumes that you want to modify",
                id: "555dd9ca-3d7e-4af3-8d63-f28a39eaeab3",
                isMultiSelect: true,
                isOptional: false,
                parameterKey: "EbsVolumeId",
                parameterLabel: "Volume ID",
                parameterType: "Volume",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                allowedValues: [
                  "standard",
                  "io1",
                  "io2",
                  "gp2",
                  "sc1",
                  "st1",
                  "gp3",
                ],
                description:
                  "The volume type you want to change the Amazon EBS volume to.",
                id: "ba3f3803-dc8b-4042-95cc-ec52e7e2a907",
                isOptional: false,
                parameterKey: "EbsVolumeType",
                parameterLabel: "Volume Type",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "DAY2",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Install the latest versions of AWS Systems Manager Agent and CloudWatch Agent on the selected machines.",
      ID: "01468d21-c923-4571-a2d0-b9d67c53b167",
      IsEnable: true,
      Metadata: {
        GlobalTask: true,
        Label: "Install SSM and CloudWatch",
        RemediationOnly: true,
        SkipParameters: true,
        SkipPermissions: true,
        TaskType: "AutomationDocument",
      },
      Name: "Install SSM and CloudWatch",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "68557b5a-cd94-452b-b22b-5fe0dc69d741",
            label:
              "Versions of AWS SSM Agent and AWS CloudWatch Agent to be installed",
            parameters: [
              {
                description: "(Required) The ID of the instance.",
                id: "555dd9ca-3d7e-4af3-8d63-f28a39eaeab3",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "Instance",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                defaultValue: "3.1.90.0",
                description:
                  "(Required) Version of Amazon SSM Agent to be installed.",
                id: "ba3f3803-dc8b-4042-95cc-ec52e7e2a9b6",
                isOptional: false,
                parameterKey: "SSMAgentVersion",
                parameterLabel: "SSM Agent Version",
                parameterType: "String",
              },
              {
                defaultValue: "1.247348.0b251302",
                description:
                  "(Required) Version of Amazon CloudWatch Agent to be installed.",
                id: "ba3f3803-dc8b-4042-95cc-ec52e7e2a561",
                isOptional: false,
                parameterKey: "CloudWatchAgentVersion",
                parameterLabel: "CloudWatch Agent Version",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Configures the S3 Bucket's versioning",
      ID: "01620840-b5f4-4dcd-bcb3-b53362b33949",
      IsEnable: true,
      Metadata: {
        Label: "Configure S3 Bucket Versioning",
        TaskType: "AutomationDocument",
      },
      Name: "ConfigureS3BucketVersioning",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "8f64a6ba-931c-481c-912b-2fd7affddd7d",
            label: "Configure S3 Bucket Versioning Parameters",
            parameters: [
              {
                description:
                  "(Required) The name of the S3 Bucket whose encryption configuration will be managed.",
                id: "bf0c0f34-0117-4be4-92a2-901fe9579884",
                isOptional: false,
                parameterKey: "BucketName",
                parameterLabel: "Bucket Name",
                parameterType: "S3",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                allowedValues: ["Enabled", "Suspended"],
                defaultValue: "Enabled",
                description:
                  "(Optional) Applied to the VersioningConfiguration.Status. When set to 'Enabled', this process enables versioning for the objects in the bucket, all objects added to the bucket receive a unique version ID. When set to 'Suspended', this process dsables versioning for the objects in the bucket, all objects added to the bucket receive the version ID null.\n",
                id: "553462f8-ce16-47b6-a295-c6132adfd36e",
                isOptional: true,
                parameterKey: "VersioningState",
                parameterLabel: "Versioning State",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "4ac0b283-34cf-4cb0-bf7a-6ebec5564162",
      Description: "",
      ID: "036650fc-291f-472f-95be-bcd7cb5fe604",
      IsEnable: true,
      Metadata: { Handler: "main_handler" },
      Name: "My Python Task",
      Owner: "Customer",
      Parameters: { parameterGroups: [] },
      TaskType: "PythonScript",
    },
    {
      Category: "BackupRestore",
      CreatedBy: null,
      Description:
        "Users can use this task to start a backup operation for a specific resource on demand. You must specify your backup vault as well as the ARN of the resource you wish to back up.",
      ID: "03a9ddf6-3cb1-4f81-abab-af9fac001014",
      IsEnable: true,
      Metadata: { Handler: "lambda_handler", Label: "Start Backup Job" },
      Name: "StartBackupJob",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635185527396-0",
            label: "Job Configurations",
            parameters: [
              {
                description:
                  "Specify the Backup vault this backup is organized in.",
                existingParameter: false,
                id: 1635185569762,
                parameterKey: "BackupVaultName",
                parameterLabel: "Backup Vault Name",
                parameterType: "String",
              },
              {
                description:
                  "An Amazon Resource Name (ARN) that uniquely identifies a resource. The format of the ARN depends on the resource type.",
                existingParameter: false,
                id: 1635185603076,
                parameterKey: "ResourceArn",
                parameterLabel: "Resource Arn",
                parameterType: "String",
              },
              {
                description:
                  "Specifies the IAM role ARN used to create the target recovery point",
                existingParameter: false,
                id: 1635185647336,
                parameterKey: "IamRoleArn",
                parameterLabel: "IAM Role Arn",
                parameterType: "IAMRole",
                primaryKey: { label: "ARN", value: "ARN" },
              },
              {
                defaultValue: "30",
                description:
                  "Specifies the number of days after creation that a recovery point is deleted. Tells how long to store your backups. AWS Backup automatically deletes you backups at the end of this period to save storage costs for you.",
                existingParameter: false,
                id: 1635185719804,
                minValue: "1",
                parameterKey: "Retentionperiod",
                parameterLabel: "Retention Period",
                parameterType: "Number",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Enable enhanced monitoring on an RDS Instance.",
      ID: "09b68416-94a7-4a5b-9dd6-1d16931878de",
      IsEnable: true,
      Metadata: {
        Label: "Enable Enhanced Monitoring On RDS Instance",
        TaskType: "AutomationDocument",
      },
      Name: "EnableEnhancedMonitoringOnRDSInstance",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "8d5fa92b-3400-46fb-8e5b-e7287f03b1d4",
            label: "Enable Enhanced Monitoring On RDS Instance Parameters",
            parameters: [
              {
                description:
                  "(Required) Resource ID of the Amazon RDS instance for which Enhanced Monitoring needs to be enabled.",
                id: "d5da14ce-434d-434d-b050-d14dd4884f45",
                isOptional: false,
                parameterKey: "ResourceId",
                parameterLabel: "Resource Id",
                parameterType: "String",
              },
              {
                allowedValues: ["1", "5", "10", "15", "30", "60"],
                defaultValue: "60",
                description:
                  "(Optional) The interval, in seconds, between points when Enhanced Monitoring metrics are collected for the DB instance.",
                id: "c0836f07-6790-4c06-aebf-259783cc029d",
                isOptional: true,
                parameterKey: "MonitoringInterval",
                parameterLabel: "Monitoring Interval",
                parameterType: "List",
              },
              {
                description:
                  "(Required) The ARN for the IAM role that permits RDS to send enhanced monitoring metrics to Amazon CloudWatch Logs.",
                id: "12e60c36-bbf1-43ce-8086-69c8e748460a",
                isOptional: false,
                parameterKey: "MonitoringRoleArn",
                parameterLabel: "Monitoring Role Arn",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Terminate Workspaces",
      ID: "0a3177c6-2bbf-5b3f-b76b-27dd0562201b",
      IsEnable: true,
      Metadata: { GlobalTask: true, Label: "Terminate WorkSpaces" },
      Name: "TerminateWorkspaces",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task lets users set the backup retention for RDS DBCluster to the specified period.",
      ID: "127d83ea-db04-4666-8468-3f48f46fe01f",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Set RDS Cluster Backup Rentention",
      },
      Name: "SetRDSBackupRentention",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635423651551-0",
            label: "RDS Configurations",
            parameters: [
              {
                description: "Name of the RDS cluster identifier",
                existingParameter: false,
                id: 1635423750890,
                parameterKey: "DBClusterIdentifier",
                parameterLabel: "DB Cluster Identifier",
                parameterType: "String",
              },
              {
                allowedValues: [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
                  34, 35,
                ],
                description:
                  "Choose the number of days that RDS should retain automatic backups for this instance.",
                existingParameter: false,
                id: 1635424088221,
                parameterKey: "BackupRetentionPeriod",
                parameterLabel: "Backup Retention Period",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "BackupRestore",
      CreatedBy: null,
      Description:
        "This task will create a logical container where backups are stored. Your account will always have a default backup vault. But if you require different encryption keys or access policies for different groups of backups, you can create multiple backup vaults. You must create at least one vault before creating a backup plan or starting a backup job.",
      ID: "14d51cb3-80ca-4cf1-ad97-f92fc5998a4d",
      IsEnable: true,
      Metadata: { Handler: "lambda_handler", Label: "Create Backup Vault" },
      Name: "CreateBackupVault",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635177714016-0",
            label: "Job Configurations",
            parameters: [
              {
                description:
                  "The name of a logical container where backups are stored. Backup vaults are identified by names that are unique to the account. They consist of letters, numbers, and hyphens.",
                existingParameter: false,
                id: 1635177789121,
                parameterKey: "BackupVaultName",
                parameterLabel: "Backup Vault Name",
                parameterType: "String",
              },
              {
                description:
                  "ARN of the server-side encryption key that is used to protect your backups.",
                existingParameter: false,
                id: 1635177827006,
                parameterKey: "EncryptionKeyArn",
                parameterLabel: "Encryption Key Arn",
                parameterType: "KMSKey",
                primaryKey: { label: "ARN", value: "ARN" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Attaches an IAM Role to an Instance",
      ID: "15d55277-4593-4df6-9a75-12ec6a40665e",
      IsEnable: true,
      Metadata: {
        Label: "Attach IAM To Instance",
        TaskType: "AutomationDocument",
      },
      Name: "AttachIAMToInstance",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "47d77d9e-e090-4f65-a609-534ad1fc76b4",
            label: "Attach IAM To Instance Parameters",
            parameters: [
              {
                description: "(Required) The ID of the instance.",
                id: "555dd9ca-3d7e-4af3-8d63-f28a39eaeab3",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "Instance",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                description: "(Required) Role Name to add",
                id: "aab1816e-4b49-4a23-9dda-19a64e44e9f2",
                isOptional: false,
                parameterKey: "RoleName",
                parameterLabel: "Role Name",
                parameterType: "IAMRole",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                allowedValues: ["true", "false"],
                defaultValue: "true",
                description:
                  "(Optional) Flag to specify whether to replace the existing iam profile or not.",
                id: "28291ffe-5fe9-4131-b971-7448b761d189",
                isOptional: true,
                parameterKey: "ForceReplace",
                parameterLabel: "Force Replace",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "996ad860-2a9a-504f-8861-aeafd0b2ae29",
      Description: "This is LeadSquared clear dynamo db script.",
      ID: "1a74f384-2dd1-410d-b3fe-6c3d2f770926",
      IsEnable: true,
      Metadata: { Handler: "lamda_handler" },
      Name: "LSQ Clear Dynamo DB Logs",
      Owner: "Customer",
      Parameters: {
        parameterGroups: [
          { id: "1592570374526-0", label: "zx", parameters: [] },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "CustomActions",
      CreatedBy: "4ac0b283-34cf-4cb0-bf7a-6ebec5564162",
      Description: "",
      ID: "1ab0e5fd-959a-436e-8ea9-e93c1c729da5",
      IsEnable: true,
      Metadata: { Handler: "" },
      Name: "My Python Task",
      Owner: "Customer",
      Parameters: { parameterGroups: [] },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Disable S3-Bucket's public Read/Write access via Block Public Access settings",
      ID: "1b38caf1-1daa-43d9-a0e8-23a0e2db5e8c",
      IsEnable: true,
      Metadata: {
        Label: "Disable S3 Bucket Public Read Write",
        TaskType: "AutomationDocument",
      },
      Name: "DisableS3BucketPublicReadWrite",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "6018cee6-d1cd-4447-9284-c0879b4eeba2",
            label: "Disable S3 Bucket Public Read Write Parameters",
            parameters: [
              {
                description:
                  "(Required) S3 Bucket subject to access restriction",
                id: "f6667621-59a9-459e-844d-5df32b39c56a",
                isOptional: false,
                parameterKey: "S3BucketName",
                parameterLabel: "S3 Bucket Name",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Executes the Packer tool to validate, fix, or build packer templates that are used to create machine images. This task is using Packer v1.4.4.",
      ID: "1c59f2ea-c86e-4f61-8703-cc4c30ab8d4b",
      IsEnable: true,
      Metadata: { Label: "Run Packer", TaskType: "AutomationDocument" },
      Name: "RunPacker",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "dde72379-80fb-41a4-b569-2b544431a24a",
            label: "Run Packer Parameters",
            parameters: [
              {
                description:
                  "(Required) AWS S3 bucket name that stores the template. eg. my-packer-bucket",
                id: "7e294749-7907-446a-92e2-097629671414",
                isOptional: false,
                parameterKey: "TemplateS3BucketName",
                parameterLabel: "Template S3 Bucket Name",
                parameterType: "String",
              },
              {
                description:
                  "(Required) Packer template file key in the bucket. eg. path/to/packer-template.json",
                id: "50b7c53b-d288-41a8-ab4f-f460f82ddc14",
                isOptional: false,
                parameterKey: "TemplateFileName",
                parameterLabel: "Template File Name",
                parameterType: "String",
              },
              {
                allowedValues: ["Validate", "Fix", "Build"],
                defaultValue: "Build",
                description:
                  "(Required) The mode in which to use Packer when validating against the template. Default Value - Build",
                id: "39d8fa13-cc11-4227-9087-516377c43be8",
                isOptional: false,
                parameterKey: "Mode",
                parameterLabel: "Mode",
                parameterType: "List",
              },
              {
                allowedValues: ["True", "False"],
                defaultValue: "True",
                description:
                  "(Optional) Forces a builder to run when artifacts from a previous build otherwise prevent a build from running. Default Value - True",
                id: "79f8258f-0ae2-4ff7-b034-565f50fb478d",
                isOptional: true,
                parameterKey: "Force",
                parameterLabel: "Force",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "996ad860-2a9a-504f-8861-aeafd0b2ae29",
      Description: "",
      ID: "1f7311ea-847e-452d-b0b5-848661bb48b0",
      IsEnable: true,
      Metadata: { Handler: "lambda_handler" },
      Name: "Python_Task_Test",
      Owner: "Customer",
      Parameters: { parameterGroups: [] },
      TaskType: "PythonScript",
    },
    {
      Category: "Security",
      CreatedBy: null,
      Description:
        "This SSM Document will launch cloud formation template, which will launch a temporary EC2 instance to generate the server and client certificates and keys using OpenVPN easy-rsa and Upload into ACm as well S3 bucket.",
      ID: "2a37ebe9-1a89-4d4d-ad3f-9a67cdd6ab3e",
      IsEnable: true,
      Metadata: { Label: "ACM Easy RSA Public Certificate" },
      Name: "ACMEasyRSAPublicCertificate",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1617962632098-0",
            label: "createacmpubliccertificates",
            parameters: [
              {
                description: "Choose an existing VPC",
                existingParameter: false,
                filterBy: { label: "Vpc", value: "Vpc" },
                id: 1617962668696,
                parameterKey: "VPC",
                parameterLabel: "VPC",
                parameterType: "Vpc",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                description: "Choose Public Subnet.",
                existingParameter: false,
                filterBy: { label: "Vpc", value: "Vpc" },
                helpLink: "",
                id: 1617962714558,
                parameterKey: "PublicSubnet",
                parameterLabel: "PublicSubnet",
                parameterType: "Subnet",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                description: "Provide S3 Bucket Name",
                existingParameter: false,
                id: 1617962750900,
                parameterKey: "S3BucketName",
                parameterLabel: "S3BucketName",
                parameterType: "String",
              },
              {
                description:
                  "Provide IAM User Name who can can access the s3 Bucket.",
                existingParameter: false,
                id: 1617962776681,
                parameterKey: "IAMUserAccessS3Bucket",
                parameterLabel: "IAMUserAccessS3Bucket",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Enables logging on S3 Bucket.",
      ID: "2a4d72f3-8a26-455d-bca6-ce01c34dd759",
      IsEnable: true,
      Metadata: {
        Label: "Configure S3 Bucket Logging",
        TaskType: "AutomationDocument",
      },
      Name: "ConfigureS3BucketLogging",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "68557b5a-cd94-452b-b22b-5fe0dc69d0ba",
            label: "Configure S3 Bucket Logging Parameters",
            parameters: [
              {
                description:
                  "(Required) The name of the S3 Bucket whose logging will be configured.",
                id: "ba3f3803-dc8b-4042-95cc-ec52e7e2a9b6",
                isOptional: false,
                parameterKey: "BucketName",
                parameterLabel: "Bucket Name",
                parameterType: "S3",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                allowedValues: ["FULL_CONTROL", "READ", "WRITE"],
                description:
                  "(Required) Logging permissions assigned to the Grantee for the bucket.",
                id: "dbc0284c-16e3-4df1-b0bc-7b0c8846c03c",
                isOptional: false,
                parameterKey: "GrantedPermission",
                parameterLabel: "Granted Permission",
                parameterType: "List",
              },
              {
                allowedValues: [
                  "CanonicalUser",
                  "AmazonCustomerByEmail",
                  "Group",
                ],
                description: "(Required) Type of grantee",
                id: "cb8c0974-0adb-4fd6-9c9d-98dd78c5aafa",
                isOptional: false,
                parameterKey: "GranteeType",
                parameterLabel: "Grantee Type",
                parameterType: "List",
              },
              {
                description:
                  "(Required) Specifies the bucket where you want Amazon S3 to store server access logs. You can have your logs delivered to any bucket that you own. You can also configure multiple buckets to deliver their logs to the same target bucket. In this case you should choose a different TargetPrefix for each source bucket so that the delivered log files can be distinguished by key.",
                id: "c25dd4f4-5732-42ed-86d0-0c6b0dd0a5c1",
                isOptional: false,
                parameterKey: "TargetBucket",
                parameterLabel: "Target Bucket",
                parameterType: "String",
              },
              {
                defaultValue: "-",
                description: "(Optional) Email address of the grantee.",
                id: "03f6de38-31ac-4671-9308-da2f334663dc",
                isOptional: true,
                parameterKey: "GranteeEmailAddress",
                parameterLabel: "Grantee Email Address",
                parameterType: "String",
              },
              {
                defaultValue: "-",
                description: "(Optional) The canonical user ID of the grantee.",
                id: "5d99c76a-3a62-4e06-b709-a8d931f0f171",
                isOptional: true,
                parameterKey: "GranteeId",
                parameterLabel: "Grantee Id",
                parameterType: "String",
              },
              {
                defaultValue: "-",
                description: "(Optional) URI of the grantee group.",
                id: "f50f7275-fe49-451b-8bd2-69285a2614b2",
                isOptional: true,
                parameterKey: "GranteeUri",
                parameterLabel: "Grantee Uri",
                parameterType: "String",
              },
              {
                defaultValue: "/",
                description:
                  "(Optional) Specifies a prefix for the keys under which the log files will be stored.",
                id: "c9733073-81d7-4579-a20d-69623602c8a4",
                isOptional: true,
                parameterKey: "TargetPrefix",
                parameterLabel: "Target Prefix",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description:
        "This task will Recover the saved resource identified by an Amazon Resource Name (ARN).",
      ID: "3c7a896e-d21e-411b-a622-e505deff3546",
      IsEnable: true,
      Metadata: { Label: "Resize Instance" },
      Name: "resizeInstance",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task will remove unused access keys older than 90 days for the specified IAM User.",
      ID: "42d95dd7-132a-4c2f-81e8-367aa871920d",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Remove unused IAM Access keys",
      },
      Name: "DeleteIAMAccessKey",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1594290778213-0",
            label: "IAM Parameters",
            parameters: [
              {
                existingParameter: false,
                id: 1633949860593,
                parameterKey: "IAMUserName",
                parameterLabel: "IAM User Name",
                parameterType: "IAMUser",
                primaryKey: { label: "Name", value: "Name" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "BackupRestore",
      CreatedBy: null,
      Description:
        "This task will recover the saved resource from the specified backup vault identified by an Amazon Resource Name (ARN).",
      ID: "4487600c-4fe3-43be-9c55-bf610820fee5",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Restore Resource from Backup",
      },
      Name: "RestoreResourceFromBackup",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635423651551-0",
            label: "Job Configurations",
            parameters: [
              {
                description:
                  "Mention the name of a logical container where backups are stored.",
                existingParameter: false,
                id: 1635423750890,
                parameterKey: "BackupVaultName",
                parameterLabel: "Backup Vault Name",
                parameterType: "String",
              },
              {
                description:
                  "Mention an Amazon Resource Name (ARN) that uniquely identifies a recovery point. It will be in format arn:aws:ec2:us-east-1::<ResourceName>/<ResourceID>",
                existingParameter: false,
                id: 1635423942577,
                parameterKey: "RecoveryPointArn",
                parameterLabel: "Recovery Point Arn",
                parameterType: "String",
              },
              {
                description:
                  "Select the Amazon Resource Name (ARN) of the IAM role that Backup uses to create the target recovery point.",
                existingParameter: false,
                id: 1635424008405,
                parameterKey: "IamRoleArn",
                parameterLabel: "IAM Role Arn",
                parameterType: "IAMRole",
                primaryKey: { label: "ARN", value: "ARN" },
              },
              {
                allowedValues: ["EC2", "EBS", "RDS"],
                description:
                  "Type of Resource for which you want to start a job to restore a recovery point",
                existingParameter: false,
                id: 1635424088221,
                parameterKey: "ResourceType",
                parameterLabel: "Resource Type",
                parameterType: "List",
              },
              {
                description:
                  "Availability zone where you would like to restore this resource. Required when you select EBS as Resource Type",
                existingParameter: false,
                id: 1635424204525,
                isOptional: true,
                parameterKey: "availabilityZone",
                parameterLabel: "Availability Zone",
                parameterType: "String",
              },
              {
                description:
                  "Specify a unique database instance identifier name. Required if you selected RDS as Resource Type",
                existingParameter: false,
                id: 1635424306638,
                isOptional: true,
                parameterKey: "DBInstanceIdentifier",
                parameterLabel: "DBInstance Identifier",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "CustomActions",
      CreatedBy: "996ad860-2a9a-504f-8861-aeafd0b2ae29",
      Description: "",
      ID: "461e6606-eb16-466d-843c-c2cb73c0aeb7",
      IsEnable: false,
      Metadata: null,
      Name: "Test-ResourceList",
      Owner: "Customer",
      Parameters: {
        parameterGroups: [
          {
            id: "1593695184203-0",
            label: "test group",
            parameters: [
              {
                defaultValue: "vpc-ivtcgjn",
                existingParameter: false,
                filterBy: { label: "Vpc", value: "Vpc" },
                id: 1593695216709,
                isMultiSelect: true,
                minRecordsToBeSelected: "1",
                parameterKey: "Name",
                parameterLabel: "message",
                parameterType: "VPC",
                primaryKey: { label: "ID", value: "ID" },
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "4ac0b283-34cf-4cb0-bf7a-6ebec5564162",
      Description: "",
      ID: "47650c26-3639-492c-83bb-c5bd9478f219",
      IsEnable: true,
      Metadata: null,
      Name: "test",
      Owner: "Customer",
      Parameters: {
        parameterGroups: [
          {
            id: "1624357093428-0",
            label: "Instance Configurations",
            parameters: [],
          },
        ],
      },
      TaskType: "RunCommand",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task will set granular access control policy for S3 service",
      ID: "54b406d0-455e-4dc4-b6ad-6fc9fd7a3c9a",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Least privilege access control for S3 Service",
      },
      Name: "RemoveS3FullAccess",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1634117250519-1",
            label: "RequiredParameters",
            parameters: [
              {
                existingParameter: false,
                id: 1634117308634,
                parameterKey: "RoleName",
                parameterLabel: "IAM Role Name",
                parameterType: "IAMRole",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                existingParameter: false,
                id: 1634117334775,
                isMultiSelect: true,
                parameterKey: "S3_ARN",
                parameterLabel: "S3 Arn",
                parameterType: "S3",
                primaryKey: { label: "ARN", value: "ARN" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Copies a point-in-time snapshot of an Amazon Elastic Block Store (Amazon EBS) volume.",
      ID: "557f214a-c69d-4446-a353-852e2824c4c3",
      IsEnable: true,
      Metadata: { Label: "Copy Snapshot", TaskType: "AutomationDocument" },
      Name: "CopySnapshot",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "baf8863b-eda7-449f-bb24-554aab5adb32",
            label: "Copy Snapshot Parameters",
            parameters: [
              {
                description: "(Required) The ID of the EBS snapshot to copy.",
                id: "f190dfcd-fde0-43c8-8334-489652822219",
                isOptional: false,
                parameterKey: "SnapshotId",
                parameterLabel: "Snapshot Id",
                parameterType: "String",
              },
              {
                description:
                  "(Required) The region where the source snapshot currently exists.",
                id: "91354d91-1949-4cf2-90e7-81c8858c6b7d",
                isOptional: false,
                parameterKey: "SourceRegion",
                parameterLabel: "Source Region",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description: "(Optional) A description for the EBS snapshot.",
                id: "d9b3b642-42d2-450f-a758-0438c40c8b00",
                isOptional: true,
                parameterKey: "Description",
                parameterLabel: "Description",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description: "(Optional) The ARN of the role assumed by lambda",
                id: "dd392ec8-8c7b-4bb0-a581-5fa25c3bb2e3",
                isOptional: true,
                parameterKey: "LambdaAssumeRole",
                parameterLabel: "Lambda Assume Role",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Enables encryption on S3 Bucket",
      ID: "55c731aa-f591-4bcb-8516-bd01ca08b8c7",
      IsEnable: true,
      Metadata: {
        Label: "Enable S3 Bucket Encryption",
        TaskType: "AutomationDocument",
      },
      BotType: BOT_TYPE_COMPLIANCE,
      Name: "EnableS3BucketEncryption",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "09d716a7-ceea-40ff-b4ef-5ea3a1d749a7",
            label: "Enable S3 Bucket Encryption Parameters",
            parameters: [
              {
                description:
                  "(Required) The name of the S3 Bucket whose content will be encrypted.",
                id: "da4fd196-7c13-4875-a104-0cbff1a39130",
                isOptional: false,
                parameterKey: "BucketName",
                parameterLabel: "Bucket Name",
                parameterType: "S3",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                defaultValue: "AES256",
                description:
                  "(Optional) Server-side encryption algorithm to use for the default encryption.",
                id: "6dab0c1f-9e66-4ea5-b928-0c4b741ddb26",
                isOptional: true,
                parameterKey: "SSEAlgorithm",
                parameterLabel: "SSE Algorithm",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Start RDS instance",
      ID: "57ae2c6b-a310-4514-b025-2847cdeb7a52",
      IsEnable: true,
      Metadata: { Label: "Start RDS Instance", TaskType: "AutomationDocument" },
      Name: "StartRdsInstance",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "0c9336f5-86fa-41b7-ac91-ce1b55b3c20a",
            label: "Start Rds Instance Parameters",
            parameters: [
              {
                description: "(Required) RDS Instance Id to start",
                id: "9551f008-ac25-408a-b6fa-e36a944e4703",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task will set granular access control policy for RDS service",
      ID: "76638918-a6b2-48bf-a425-eb2e650274b9",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Least privilege access control for RDS Service",
      },
      Name: "RemoveRDSFullAccess",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1634117250519-1",
            label: "RequiredParameters",
            parameters: [
              {
                existingParameter: false,
                id: 1634117308634,
                parameterKey: "RoleName",
                parameterLabel: "IAM Role Name",
                parameterType: "IAMRole",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                existingParameter: false,
                id: 1634117334775,
                isMultiSelect: true,
                parameterKey: "RDS_ARN",
                parameterLabel: "RDS Arn",
                parameterType: "Rds",
                primaryKey: { label: "ARN", value: "ARN" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Enables or disables CloudWatch monitoring on an EC2 instance.",
      ID: "78ac9d1b-2210-48e8-8a69-ac34e38368f0",
      IsEnable: true,
      Metadata: {
        Label: "Configure CloudWatch On EC2 Instance",
        TaskType: "AutomationDocument",
      },
      Name: "ConfigureCloudWatchOnEC2Instance",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "7099b866-1c5c-4093-b646-2962442d1476",
            label: "Configure CloudWatch On EC 2 Instance Parameters",
            parameters: [
              {
                description:
                  "(Required) The ID of the EC2 instance on which you want to enable CloudWatch monitoring.",
                id: "75fd9a62-6443-4123-86bf-fab64569ac24",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "Instance",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                allowedValues: ["Enabled", "Disabled"],
                defaultValue: "Enabled",
                description:
                  '(Optional) Specifies whether to enable or disable CloudWatch. Valid values: "Enabled" | "Disabled"',
                id: "5e583dd8-27d2-4eac-aa44-806e6d457248",
                isOptional: true,
                parameterKey: "status",
                parameterLabel: "Status",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "BackupRestore",
      CreatedBy: null,
      Description:
        "This task helps users specify a set of resources to assign to a backup plan. You will need to mention resources ARN which you want to assign to a backup plan.",
      ID: "78f97a63-7e0f-4c59-9490-074caf49d605",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Configure Backup Resources",
      },
      Name: "ConfigureBackupResources",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635184038611-0",
            label: "Job Configurations",
            parameters: [
              {
                description:
                  "Id of the backup plan to be associated with the selection of resources.",
                existingParameter: false,
                id: 1635184117494,
                parameterKey: "BackupPlanId",
                parameterLabel: "Backup PlanId",
                parameterType: "String",
              },
              {
                description:
                  "The display name of a resource selection document.",
                existingParameter: false,
                id: 1635184185840,
                parameterKey: "SelectionName",
                parameterLabel: "Selection Name",
                parameterType: "String",
              },
              {
                description:
                  "The ARN of the IAM role that Backup uses to authenticate when backing up the target resource",
                existingParameter: false,
                id: 1635184246673,
                parameterKey: "IamRoleArn",
                parameterLabel: "IAM Role Arn",
                parameterType: "IAMRole",
                primaryKey: { label: "ARN", value: "ARN" },
              },
              {
                description:
                  "An array of strings that contain Amazon Resource Names (ARNs) of resources to assign to a backup plan",
                existingParameter: false,
                id: 1635184440824,
                isMultiSelect: true,
                parameterKey: "ListofResourcesARN",
                parameterLabel: "List of Resources ARN",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Enables a user to stop, start, restart, pause, or disable any Windows service on the target instance.",
      ID: "865107c8-7597-4623-bfee-273cba1e8d18",
      IsEnable: true,
      Metadata: {
        Label: "Manage Windows Service",
        TaskType: "AutomationDocument",
      },
      Name: "ManageWindowsService",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "e1dc7f1e-5577-4d06-9679-cf5769942646",
            label: "Manage Windows Service Parameters",
            parameters: [
              {
                description:
                  "(Required) The ID of the managed instance to manage the RDP settings of.",
                id: "2f857e77-aa67-458f-8383-a2ab159a4800",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "Instance",
                primaryKey: { label: "ID", value: "ID" },
              },
              {
                description: "(Required) A valid Windows service name.",
                id: "e099fffb-6563-40b1-8921-00810ec2a5f4",
                isOptional: false,
                parameterKey: "WindowsServiceName",
                parameterLabel: "Windows Service Name",
                parameterType: "String",
              },
              {
                allowedValues: [
                  "Check",
                  "Auto",
                  "Demand",
                  "Disabled",
                  "DelayedAutoStart",
                ],
                defaultValue: "Check",
                description:
                  "(Required) A startup type to apply to the Windows service: Auto, Demand (Manual), Disabled, DelayAutoStart, Check.",
                id: "cea79270-6942-4c35-b96b-cfdb8f72c748",
                isOptional: false,
                parameterKey: "StartupType",
                parameterLabel: "Startup Type",
                parameterType: "List",
              },
              {
                allowedValues: [
                  "Check",
                  "Restart",
                  "Force-Restart",
                  "Start",
                  "Stop",
                  "Force-Stop",
                  "Pause",
                ],
                defaultValue: "Check",
                description:
                  "(Required) An action to apply to the Windows service: Restart, Force-Restart, Start, Stop, Force-Stop, Pause, Check. Note: Force-Restart and Force-Stop can be used to restart and to stop a service that has dependent services.",
                id: "7ce218d4-1948-4184-984e-e6a492612cc9",
                isOptional: false,
                parameterKey: "ServiceAction",
                parameterLabel: "Service Action",
                parameterType: "List",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Diagnose connectivity issues with the database running on the Relational Database Service.",
      ID: "877c551e-cec7-4af8-a984-a75a19499de9",
      IsEnable: true,
      Metadata: {
        Label: "Troubleshoot Connectivity To RDS",
        TaskType: "AutomationDocument",
      },
      Name: "TroubleshootConnectivityToRDS",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "7f204b15-4f3f-4503-b6b9-e0fa6b366f87",
            label: "Troubleshoot Connectivity To RDS Parameters",
            parameters: [
              {
                defaultValue: "",
                description:
                  "(Required) Specify the DB Instance Identifier here if you want to test the connectivity with any specific DB instance.",
                id: "2b2b277f-a234-405d-83be-8c1aab0d7ab9",
                isOptional: false,
                parameterKey: "DBInstanceIdentifier",
                parameterLabel: "DB Instance Identifier",
                parameterType: "String",
              },
              {
                defaultValue: "",
                description:
                  "(Required) Instance ID from where you are attempting to connect with the RDS server.",
                id: "435d24cb-9ef8-4b14-a678-ba2a64684c80",
                isOptional: false,
                parameterKey: "SourceInstance",
                parameterLabel: "Source Instance",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Delete Snapshot",
      ID: "8bd6d78a-f5b6-4b0d-bade-5a7057729f09",
      IsEnable: true,
      Metadata: { Label: "Delete Snapshot", TaskType: "AutomationDocument" },
      Name: "DeleteSnapshot",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "12e2f75e-2ce1-4bf9-b7f2-76acbd9f4c8a",
            label: "Delete Snapshot Parameters",
            parameters: [
              {
                description: "(Required) The ID of the EBS snapshot.",
                id: "137a87ee-1321-4a1b-ba28-6899fe664e60",
                isOptional: false,
                parameterKey: "SnapshotId",
                parameterLabel: "Snapshot Id",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task will set granular access control policy for DynamoDB service",
      ID: "9502a9b8-80a2-4654-9155-4265b2eac158",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Least privilege access control for DynamoDB Service",
      },
      Name: "RemoveDynamoDbFullAccess",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1634117250519-1",
            label: "RequiredParameters",
            parameters: [
              {
                existingParameter: false,
                id: 1634117308634,
                parameterKey: "RoleName",
                parameterLabel: "IAM Role Name",
                parameterType: "IAMRole",
                primaryKey: { label: "Name", value: "Name" },
              },
              {
                existingParameter: false,
                id: 1634117334775,
                isMultiSelect: true,
                parameterKey: "Table_ARN",
                parameterLabel: "DynamoDB Table Arn",
                parameterType: "DynamoDbTable",
                primaryKey: { label: "ARN", value: "ARN" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Deletes an unused IAM group.",
      ID: "95c00526-3c02-4096-a51b-6653cdd01a81",
      IsEnable: true,
      Metadata: {
        Label: "Delete Unused IAM Group",
        TaskType: "AutomationDocument",
      },
      Name: "DeleteUnusedIAMGroup",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "0ec80771-9ac2-40d1-a2f5-93a549c55d7a",
            label: "Delete Unused IAM Group Parameters",
            parameters: [
              {
                description:
                  "(Required) Group name of the IAM Group to delete. Group Name must be maximum 128 characters and contain only alphanumeric characters and/or the following +=,.@-_",
                id: "d8859f9b-6deb-478f-84ff-debae5ff0b8a",
                isOptional: false,
                parameterKey: "GroupName",
                parameterLabel: "Group Name",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "996ad860-2a9a-504f-8861-aeafd0b2ae29",
      Description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas at nibh quis diam bibendum tempus. Nam at condimentum ligula, nec placerat odio. Maecenas ac felis sit amet sem placerat ullamcorper quis a mauris. Nam mattis nisi id sem dignissim luctus. ",
      ID: "96771a51-e27a-4c0b-907f-09e2933361cb",
      IsEnable: true,
      Metadata: null,
      Name: "My test task for my company",
      Owner: "Customer",
      Parameters: {
        parameterGroups: [
          {
            id: "1603343258730-0",
            label: "My Parameter Group",
            parameters: [
              {
                description: "shdiasdiasjdiasdjiasd",
                existingParameter: false,
                id: 1603343274479,
                parameterKey: "abc",
                parameterLabel: "test",
                parameterType: "Certificate",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "4ac0b283-34cf-4cb0-bf7a-6ebec5564162",
      Description: "",
      ID: "96ee6678-a9ae-4c6e-a455-464f8cb63cb2",
      IsEnable: true,
      Metadata: { Handler: "main_handler" },
      Name: "My Python Task",
      Owner: "Customer",
      Parameters: { parameterGroups: [] },
      TaskType: "PythonScript",
    },
    {
      Category: "BackupRestore",
      CreatedBy: null,
      Description:
        "This task will create a backup plan. A backup plan is a policy expression that defines when and how you want to back up your AWS resources, such as Amazon EC2 or RDS instances. This also includes backup schedules, backup retention rules and lifecycle rules.",
      ID: "9d2c867a-8feb-4c85-96e4-0dda6f9bd1f6",
      IsEnable: true,
      Metadata: { Handler: "lambda_handler", Label: "Create Backup Plan" },
      Name: "CreateBackupPlan",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1635183223571-0",
            label: "Job Configurations",
            parameters: [
              {
                description:
                  "Name your backup plan. Backup plan name is case sensitive. Must contain from 1 to 50 alphanumeric and '-_.' characters.",
                existingParameter: false,
                id: 1635183242872,
                parameterKey: "BackupPlanName",
                parameterLabel: "Backup Plan Name",
                parameterType: "String",
              },
              {
                description:
                  "Name the Rule. Backup rule name is case sensitive. Must contain from 1 to 50 alphanumeric and '-_.' characters.",
                existingParameter: false,
                id: 1635183256922,
                parameterKey: "RuleName",
                parameterLabel: "Rule Name",
                parameterType: "String",
              },
              {
                description:
                  "The name of a logical container where backups are stored. Backups are stored in the specified backup vault.",
                existingParameter: false,
                id: 1635183281416,
                parameterKey: "TargetBackupVaultName",
                parameterLabel: "Target Backup Vault Name",
                parameterType: "String",
              },
              {
                defaultValue: "cron(0 12 * * ? *)",
                description:
                  "A CRON expression in UTC specifying when Backup initiates a backup job.",
                existingParameter: false,
                id: 1635183307489,
                parameterKey: "BackupScheduleExpression",
                parameterLabel: "Backup Schedule Expression",
                parameterType: "String",
              },
              {
                defaultValue: "30",
                description:
                  "Specifies the number of days after creation that a recovery point is deleted. Tells how long to store your backups. AWS Backup automatically deletes your backups at the end of this period to save storage costs for you.",
                existingParameter: false,
                id: 1635183330782,
                minValue: "1",
                parameterKey: "Retentionperiod",
                parameterLabel: "Retention Period",
                parameterType: "Number",
              },
              {
                description:
                  "An Amazon Resource Name (ARN) that uniquely identifies the destination backup vault for the copied backup. If you mention backup vault ARN of another region, It will create cross-Region copies of your recovery points.",
                existingParameter: false,
                id: 1635183347227,
                parameterKey: "DestinationBackupVaultArn",
                parameterLabel: "Destination Backup Vault Arn",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "CustomActions",
      CreatedBy: "aba1d5e5-70f5-4189-b971-a2749aa76f01",
      Description: "",
      ID: "aaf1d4c0-736c-41eb-8487-9e7d3acb0801",
      IsEnable: true,
      Metadata: null,
      Name: "Test - AJ",
      Owner: "Customer",
      Parameters: {
        parameterGroups: [
          {
            id: "1612515899597-0",
            label: "Test1",
            parameters: [
              {
                existingParameter: false,
                id: 1612515934982,
                parameterKey: "test1-param1",
                parameterLabel: "test1-param1",
                parameterType: "AutoScalingGroup",
              },
              {
                existingParameter: false,
                id: 1612515954311,
                parameterKey: "test1-param2",
                parameterLabel: "test1-param2",
                parameterType: "Certificate",
              },
            ],
          },
          { id: "1612515906029-1", label: "Test2", parameters: [] },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Reboot Workspaces",
      ID: "b325fc99-6109-5c57-82c3-3a61c94aee6d",
      IsEnable: true,
      Metadata: { GlobalTask: true, Label: "Reboot WorkSpaces" },
      Name: "RebootWorkspaces",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Start Workspaces",
      ID: "b472ee5d-24a2-5509-94ea-53573c7fcceb",
      IsEnable: true,
      Metadata: { GlobalTask: true, Label: "Start WorkSpaces" },
      Name: "StartWorkspaces",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Creates a Jira issue.",
      ID: "bba4c339-f53b-4efe-9f81-d111f030492d",
      IsEnable: true,
      Metadata: { Label: "Create Jira Issue", TaskType: "AutomationDocument" },
      Name: "CreateJiraIssue",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "4d9a516e-884a-44fc-8931-45ba45dc626a",
            label: "Create Jira Issue Parameters",
            parameters: [
              {
                description:
                  "(Required) The name of the user the issue will be created with.",
                id: "b0721f71-94c2-4123-b464-9779caac8aa3",
                isOptional: false,
                parameterKey: "JiraUsername",
                parameterLabel: "Jira Username",
                parameterType: "String",
              },
              {
                description:
                  "(Required) The name of an encrypted SSM Parameter containing the API key or password for the Jira user.",
                id: "a6bb1f17-c066-4ea8-95fc-840a22d23ef7",
                isOptional: false,
                parameterKey: "SSMParameterName",
                parameterLabel: "SSM Parameter Name",
                parameterType: "String",
              },
              {
                description: "(Required) The url of the Jira instance.",
                id: "98340461-0640-4f6f-9089-51747b135477",
                isOptional: false,
                parameterKey: "JiraURL",
                parameterLabel: "Jira URL",
                parameterType: "String",
              },
              {
                description:
                  "(Required) The key of the project the issue should be created in.",
                id: "894f673c-e66e-4e30-a184-df7f7316af16",
                isOptional: false,
                parameterKey: "ProjectKey",
                parameterLabel: "Project Key",
                parameterType: "String",
              },
              {
                description: "(Required) A brief summary of the issue.",
                id: "fc986080-f25e-42f8-9202-19fa75f0ce01",
                isOptional: false,
                parameterKey: "IssueSummary",
                parameterLabel: "Issue Summary",
                parameterType: "String",
              },
              {
                description: "(Required) A detailed description of the issue.",
                id: "742c6fbc-1cda-483b-9f27-cffc11e825bd",
                isOptional: false,
                parameterKey: "IssueDescription",
                parameterLabel: "Issue Description",
                parameterType: "String",
              },
              {
                description:
                  "(Required) The name of the type of issue you want to create (ex. Task, Sub-task, Bug, etc).",
                id: "06d2dd30-3a7f-4be7-bd03-29d71a42cce0",
                isOptional: false,
                parameterKey: "IssueTypeName",
                parameterLabel: "Issue Type Name",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description:
                  "(Optional) The name of the priority of the issue.",
                id: "64aaa88f-ff1b-4378-8edb-91525f7d2461",
                isOptional: true,
                parameterKey: "PriorityName",
                parameterLabel: "Priority Name",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description:
                  "(Optional) The username of the person the issue should be assigned to.",
                id: "6cb193c1-3d12-4ee1-bf37-d5f3a9eac283",
                isOptional: true,
                parameterKey: "AssigneeName",
                parameterLabel: "Assignee Name",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description:
                  "(Optional) The due date for the issue in yyyy-mm-dd format.",
                id: "f318dd33-570e-4f62-95e6-cddd85364e0c",
                isOptional: true,
                parameterKey: "DueDate",
                parameterLabel: "Due Date",
                parameterType: "String",
              },
              {
                defaultValue: " ",
                description:
                  "(Optional) The ARN of the role that allows Lambda created by Automation to perform the actions on your behalf. If not specified a transient role will be created to execute the Lambda function.",
                id: "790ca2f7-a22b-4acb-ac19-32a6958c8c64",
                isOptional: true,
                parameterKey: "LambdaAssumeRole",
                parameterLabel: "Lambda Assume Role",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "CustomActions",
      CreatedBy: "996ad860-2a9a-504f-8861-aeafd0b2ae29",
      Description: "",
      ID: "c5c4e27f-6bf1-437b-aa8b-806f0ce21f88",
      IsEnable: true,
      Metadata: null,
      Name: "fgh",
      Owner: "Customer",
      Parameters: { parameterGroups: [] },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Storage",
      CreatedBy: null,
      Description: "Delete a AWS EBS snapshot",
      ID: "caad569b-9a98-5d3e-8ae6-ad63254dedc0",
      IsEnable: true,
      Metadata: { GlobalTask: true },
      Name: "deleteSnapshot",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "EC2",
      CreatedBy: null,
      Description: "Stop Workspaces",
      ID: "cf009521-909c-5198-88e1-f1a5baf4829b",
      IsEnable: true,
      Metadata: { GlobalTask: true, Label: "Stop WorkSpaces" },
      Name: "StopWorkspaces",
      Owner: "MontyCloud",
      Parameters: null,
      TaskType: "DAY2",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Publish SNS Notification",
      ID: "e110fbdc-92e7-4f29-9f28-cd51873c019c",
      IsEnable: true,
      Metadata: {
        Label: "Publish SNS Notification",
        TaskType: "AutomationDocument",
      },
      Name: "PublishSNSNotification",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "7d1fca19-eb33-472e-b940-00c96f7b1926",
            label: "Publish SNS Notification Parameters",
            parameters: [
              {
                description:
                  "(Required) The ARN of the SNS topic to publish the notification to.",
                id: "42126033-b9c6-4cd7-a66e-c64908140380",
                isOptional: false,
                parameterKey: "TopicArn",
                parameterLabel: "Topic Arn",
                parameterType: "String",
              },
              {
                description:
                  "(Required) The message to include in the SNS notification.",
                id: "8932e5c7-7723-4842-afdb-23928cadb4b4",
                isOptional: false,
                parameterKey: "Message",
                parameterLabel: "Message",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description:
        "Disable SSH and RDP ports opened to IP address specified, or to all addresses if no address is specified.",
      ID: "e4696191-bfa7-494c-87b3-feef332e5a3c",
      IsEnable: true,
      Metadata: {
        Label: "Disable Public Access For Security Group",
        TaskType: "AutomationDocument",
      },
      Name: "DisablePublicAccessForSecurityGroup",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "ac7f7cad-07d1-419d-a801-1f562b630066",
            label: "Disable Public Access For Security Group Parameters",
            parameters: [
              {
                description: "(Required) Security Group ID",
                id: "c289aaf5-2733-46fc-b8ed-25b50446f91b",
                isOptional: false,
                parameterKey: "GroupId",
                parameterLabel: "Group Id",
                parameterType: "String",
              },
              {
                defaultValue: "",
                description:
                  "(Optional) Additional Ipv4 or Ipv6 address to block access from (ex:1.2.3.4/32)",
                id: "cdaeed60-f575-41a7-976c-01d7de102b20",
                isOptional: true,
                parameterKey: "IpAddressToBlock",
                parameterLabel: "Ip Address To Block",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description:
        "This task will enable object versioning at the bucket level",
      ID: "e8825a74-0347-44ee-9911-613d9daebabf",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Enable S3 Object Versioning",
      },
      Name: "EnableS3ObjectVersioning",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1634117250519-1",
            label: "RequiredParameters",
            parameters: [
              {
                existingParameter: false,
                id: 1634117334775,
                isMultiSelect: true,
                parameterKey: "BucketName",
                parameterLabel: "Bucket Name",
                parameterType: "S3",
                primaryKey: { label: "Name", value: "Name" },
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      Category: "Compliance",
      CreatedBy: null,
      Description: "Stop RDS instance",
      ID: "f3e5cdad-65bd-43ff-9ccc-03e74650c87f",
      IsEnable: true,
      Metadata: { Label: "Stop RDS Instance", TaskType: "AutomationDocument" },
      Name: "StopRdsInstance",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "a98c388d-3c82-4f7b-892a-a7862e429f05",
            label: "Stop Rds Instance Parameters",
            parameters: [
              {
                description: "(Required) RDS Instance Id to stop",
                id: "7814a3c8-a973-448c-8a6a-78b0295b9895",
                isOptional: false,
                parameterKey: "InstanceId",
                parameterLabel: "Instance Id",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "AutomationDocument",
    },
    {
      Category: "Remediation",
      CreatedBy: null,
      Description: "This task will set log file validation for CloudTrail.",
      ID: "f52f190b-28df-4a34-89a7-d6517d0f6cfe",
      IsEnable: true,
      Metadata: {
        Handler: "lambda_handler",
        Label: "Enable CloudTrail Log File Validation",
      },
      Name: "CloudTrailLogFileValidation",
      Owner: "MontyCloud",
      Parameters: {
        parameterGroups: [
          {
            id: "1634117250519-1",
            label: "RequiredParameters",
            parameters: [
              {
                existingParameter: false,
                id: 1634117308634,
                parameterKey: "TrailName",
                parameterLabel: "CloudTrail Name",
                parameterType: "String",
              },
            ],
          },
        ],
      },
      TaskType: "PythonScript",
    },
    {
      ID: uuidv4(),
      Name: "Remove all Inbound and Outbound Rules",
      Description:
        "This removes all inbound and outbound rules for the specified security group which helps stop all traffic passing through this source.",
      BotType: BOT_TYPE_SECURITY,
      Owner: "MontyCloud",
      Role: "security-bot",
      Parameters: {
        parameterGroups: [
          {
            id: "295a7d6f-3a8e-47cb-a4de-be1ff6e4304a",
            label: "AWS-AttachIAMToInstance",
            parameters: [
              {
                id: "2ff98fd9-2587-409d-a4d4-74bb233c32c3",
                description: "(Required) The ID of the instance.",
                parameterKey: "InstanceId",
                parameterType: "String",
                parameterLabel: "Instance Id",
              },
              {
                id: "18855802-4411-48d0-9799-eca6aeae69e1",
                description: "(Required) Role Name to add",
                isMultiSelect: false,
                parameterKey: "RoleName",
                parameterType: "IAMRole",
                parameterLabel: "Role Name",
                defaultValue: "",
              },
              {
                id: "25580e09-94cc-4b7f-a3f4-39bba3ed0c02",
                isOptional: true,
                description:
                  "(Optional) Flag to specify whether to replace the existing iam profile or not.",
                parameterKey: "ForceReplace",
                parameterLabel: "Force Replace",
                allowedValues: ["true", "false"],
                defaultValue: "true",
                isMultiSelect: false,
                parameterType: "List",
              },
            ],
          },
        ],
      },
    },
  ];

  allCustomTasks.forEach(function (element) {
    if (!element.ID) {
      element.ID = uuidv4();
    }
    if (botId) {
      const botType = getBotType(botId);
      if (element.BotType === botType) {
        element.IsRecommendedTask = true;
      }
    }
    if (!element.TaskType && !element.IsRecommendedTask) {
      element.TaskType = "PythonScript";
    }
    if (!element.Owner) {
      element.Owner = "MontyCloud";
    }
    if (!element.CreatedBy) {
      element.CreatedBy = null;
    }
    element.Enabled = faker.random.boolean();

    if (!element.IsEnable) {
      element.IsEnable = true;
    }
  });
  return allCustomTasks;
};

export const getDesiredTaskDetails = (id) => {
  let task = {};
  if (
    [DESIRED_ACCOUNT_STATE_TASK_ID, DESIRED_REGION_STATE_TASK_ID].includes(id)
  ) {
    task = { Role: "My-Task-Role" };
  }
  return task;
};

export const preProcessImportedTasks = (taskList) => {
  let newTaskList =
    taskList &&
    taskList.map((task) => {
      let taskObj = {
        ApplicationId: null,
        BlueprintId: null,
        Category: "EC2",
        actionId: task.ID,
        description: task.Description,
        enabled: task.IsEnable || true,
        isImported: true,
        metadata: {},
        name: getTaskType(task).taskName,
        owner: task.Owner,
        type: task.TaskType || getTaskType(task).type,
      };
      return taskObj;
    });
  return newTaskList;
};
